<style>
.lineup {
    font-family: Gotham Pro, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 19px;
    text-align: center;
    color: #FF0000;
    margin-bottom: 31px;
}
.eda{
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    align-content: flex-start;
}
</style>

<script>
    import { load, mutations, actions, trackArray, tabImagesArray, combinedArray } from '../mainStore.js';
    import TrackPreview from './TrackPreview.svelte';
    import config from '../config';

    async function getTrackData(event){
        try {
            mutations.setPreloader(true)
            let track = event.detail.track;
            mutations.setTrack(track);
            await actions.getItems(track.id)
            mutations.setStep(2);
            mutations.clearGoodsList();
            mutations.setPreloader(false)
        }
        catch(e){
            mutations.setPreloader(false)
            console.log(e)
        }
    }
</script>
<div class="lineup">
    Модельный ряд
</div>
<div class="eda">
    {#if ($load == true)}
        {#each $trackArray as track }
            <TrackPreview track={track} on:clickOnTrack={getTrackData} />
        {/each}
    {:else}
        <p>загрузка</p>
    {/if}

</div>
